var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "cargo-advance-select",
        _vm._b(
          {
            ref: "selectRef",
            attrs: { "default-value": _vm.value },
            on: {
              "visible-change": _vm.onBlur,
              parentCallBack: _vm.valueChange
            }
          },
          "cargo-advance-select",
          _vm.params.selectProps,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }